<template>
  <div id="GoodsList">
    <div class="list_slide_box">
      <div class="slide_box" v-for="(item, index) in list" :key="index"
        :class="[item.Status!=1?'sold soldout':'',type=='card'&&item.QuantitySold<=0?'soldout':'',type=='card'&&item.MyLastOnTime!=''&&item.Status==1?'soldout':'',item.EffectiveTime!='Ended listing'?'':'soldout']">
        <!-- <span class="favorite" @click="favorite(item)"  :class="item.IsAttention ? 'on' : ''" v-if="type!='card'&&userInfo != null"></span> -->
        <!-- <div class="iconsold" v-if="(type=='card'&&item.QuantitySold<=0&&item.OrderType==1&&item.MyLastOnTime=='')||(item.Status!=1&&item.OrderType!=1)" @click="goto(item.ID)"></div> -->
        <div class="iconsold ReleaseType" v-if="type=='card'&&item.MyLastOnTime!=''&&item.Status==1" @click="goto(item.ID)"></div>
        <router-link :to="{path:'/carddetails/'+item.ID}" target="_blank">
          <div class="like_box">
            <div class="iconsold" v-if="(type=='card'&&item.QuantitySold<=0&&item.OrderType==1&&item.MyLastOnTime=='')||(item.Status!=1&&item.OrderType!=1)">{{$t('base.soldOut')}}</div>
            <div class="iconsold ReleaseType" v-if="type=='card'&&item.MyLastOnTime!=''&&item.Status==1">{{$t('base.comingSoon')}}</div>
            <div class="icon_vault" v-if="item.IsValut" ></div>
            <!-- <div class="like_img">
              <img :src="item.TitImg!='没有可上传的图片'?item.TitImg:'../static/images/noimg.svg'"/>
            </div> -->
            <el-image class="like_img" :src="item.TitImg+'?imageView2/2/w/200'" fit="contain" lazy>
              <img slot="error" src="../../../static/images/noimg.svg" class="el-image__inner" style="object-fit: contain;">
            </el-image>
          </div>
          <div class="slide_txt">
            <div class="text_greed_m" :class="item.Status!=1?'text_greed':''" v-if="item.Status!=1&&type!='recently'">{{$t('enum.sold')}}
              {{item.EffectiveDate|setTimeSS}}</div>
            <div v-if="type=='recently'&&item.Status!=1" class="text_greed_m" :class="item.Status!=1?'text_greed':''">{{$t('enum.sold')}}
              {{item.EffectiveDate|setTimeSS}}
            </div>
            <div v-if="type=='recently'&&item.Status==1" class="text_greed_m" :class="item.Status!=1?'text_greed':''">&nbsp;
            </div>
            <p class="line_txt3" :title="item.Title">{{item.Title}}</p>
            <!-- :class="StatusNum==2?'text_greed':''" -->
            <div class="price" v-if="type!='card'">{{areaSymbol}} {{ type=='search' || type=='seller'?item.USD_LowestPrice:item.USD_Price}}</div>
            <div class="price" v-else>{{item.MyLastOnTime==''?areaSymbol+' '+item.USD_Price:areaSymbol+' ???'}}</div>
            <!-- <span class="fare">$ {{ item.yunfei }} Shipping</span> -->

            <div class="bids_box" v-if="type=='recently'">
              <span v-if="item.ByWay!=1" class="icon_auction"
                :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{ item.AuctionCount }}
                {{ item.AuctionCount != 1?$t('base.bids'):$t('base.bid')}}</span>
              <span v-else class="icon_flash" :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{$t('base.buyNow')}}</span>
              <span v-if="item.OrderType!=1&&item.Status==1" class="icon_hour"
                :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{CountDown(item.EffectiveDate)}}</span>
            </div>
            <div class="bids_box" v-else>
              <span v-if="item.ByWay!=1" class="icon_auction" :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{ item.OutCount }}
                {{ item.OutCount != 1?$t('base.bids'):$t('base.bid')}}</span>
              <span v-else class="icon_flash" :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{$t('base.buyNow')}}</span>
              <span v-if="item.OrderType!=1&&item.Status==1" class="icon_hour"
                :class="getCountDown(item.EffectiveDate)==1&&item.Status==1?'text_red':''">{{CountDown(item.EffectiveDate)}}</span>
            </div>
          </div>

        </router-link>

      </div>
    </div>
  </div>
</template>
<script>
import { countDown, setUTC, getTime, setAttention, getInfo, titleSubstring } from "@/api/public";
export default {
  name: "goodslist",
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      userInfo: '',
      timer: "",
      nowData: new Date().getTime(),
    };
  },
  filters: {
    setTimeSS(val) {
      if (val) {
        val = val.toString().replace(/-/g, "/")
      }
      return getTime(val, -8, 1, 'cn')
    },
    titleVal(data) {
      /* 商品列表标题截取 */
      return titleSubstring(data);
    }
  },
  props: {
    list: {},
    StatusNum: "",
    type: ''
  },
  created() {
    this.userInfo = getInfo();
    this.cardTimer();
  },
  methods: {
    goto(id){
      window.open('#/carddetails/'+id, '_blank');
    },
    favorite(obj) {
      let id = obj.ID;
      obj.IsAttention = !obj.IsAttention;
      setAttention(id, 0)
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },

    getCountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval)
    },
  },
  //离开页面后清除定时器
  destroyed() {
    clearInterval(this.timer);
  }
};

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/goodslist.css";
</style>



// WEBPACK FOOTER //
// src/components/list/goods.vue